import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Heading from "@commons/Typography/Heading";
import Button from "@commons/Button";
import Text from "../Typography/Text";

type InfoModalProps = {
  open: boolean;
  title: string;
  message: string;
  onClose: () => void;
  buttonLabel?: string;
};

function InfoModal({
  open,
  title,
  message,
  onClose,
  buttonLabel = "Entendi",
}: InfoModalProps) {
  if (!open) return null;

  return (
    <div
      data-testid="info-modal"
      className="fixed inset-0 backdrop-opacity-80 bg-accent/60 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="max-w-md w-full bg-white rounded-lg shadow-xl flex flex-col"
        role="dialog"
        aria-modal="true"
        tabIndex={-1}
        onClick={(e) => e.stopPropagation()}
      >
        <section className="relative p-4 flex items-center justify-end">
          <IconButton onClick={onClose} className="h-8 w-8" aria-label="Fechar">
            <CloseIcon />
          </IconButton>
        </section>

        <section className="px-6 pb-6 flex flex-col items-center text-center gap-4">
          <div className="p-3 rounded-full bg-blue-50">
            <InfoOutlinedIcon className="text-4xl text-blue-600" />
          </div>

          <Heading size="md" className="font-semibold">
            {title}
          </Heading>

          <Text size="md" className="text-gray-600">
            {message}
          </Text>
        </section>

        <section className="p-6 pt-2 flex justify-center">
          <Button
            customVariant="primary"
            size="sm"
            onClick={onClose}
            className="min-w-[120px]"
          >
            <Text size="sm" className="font-roboto font-semibold">
              {buttonLabel}
            </Text>
          </Button>
        </section>
      </div>
    </div>
  );
}

export default InfoModal;
